import { CircularProgress } from "@mui/material";

/**
 * LoadingOverlay component
 * A customized loading overlay that displays a spinner and text
 *
 * @param {Object} props - Component props
 * @param {boolean} props.active - Whether the overlay is active/visible
 * @param {string} props.text - Text to display below the spinner
 * @param {boolean} props.spinner - Whether to show the spinner
 * @param {boolean} props.containerOnly - Whether the overlay should only cover its container
 * @param {string} props.classNamePrefix - Optional prefix for CSS classes
 * @param {React.ReactNode} props.children - Content to be overlaid
 */
const LoadingOverlay = ({
    active = false,
    text = "Loading...",
    spinner = true,
    containerOnly = false,
    classNamePrefix = "loading-overlay_",
    children,
}) => {
    const prefix = classNamePrefix || "loading-overlay_";
    const baseClass = containerOnly
        ? "container-loading-overlay"
        : "loading-overlay";

    return (
        <div className={`${baseClass}-container`}>
            {children}

            {active && (
                <div
                    className={`${baseClass} ${prefix}wrapper`}
                    aria-live="polite"
                >
                    <div
                        className={`${baseClass}__backdrop ${prefix}backdrop`}
                    ></div>
                    <div className={`${baseClass}__content ${prefix}content`}>
                        {spinner && (
                            <div
                                className={`${baseClass}__spinner ${prefix}spinner`}
                            >
                                <CircularProgress color="inherit" />
                            </div>
                        )}
                        {text && (
                            <div className={`${baseClass}__text ${prefix}text`}>
                                {text}
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default LoadingOverlay;
